import type { GalleryGoalOption } from "./galleryGoals";

// The four goals the signed jewelry design lists (App Onboarding.dc.html, `GOALS.jewelry`), in
// that order. Values are SignupIntent flags, so a selection is the same bitmask the registration
// POST has always carried. `analyticsLabel` carries the same weight it does in galleryGoals.ts (see
// that file's GalleryGoalOption doc): it is the word `Intent.displayType()` puts in
// page/Onboarding.jsx's `'OB: Intent Declared'` payload, not the chip's own copy - both wizards
// feed the same ACA-95 funnel.
//
// No ordinal for User.Type travels with this table. A Jewelry account is a Gallery account
// (UserType 3) with DefaultInventoryType = ArtType.Jewelry (5); that value reaches the container by
// its own prop (jewelryInventoryTypeValue), not from here.
//
// `Marketplace` (32) and `BusinessOperations` (16) are reused on purpose, not duplicated by
// accident, the same way COLLECTOR_GOALS reuses `Catalogue` (256). "Sell on the marketplace" and
// "Run our business" are the same acts for a jewelry account as for a gallery, so the two lists
// sharing these two bits is a decision, not an automatism.
export const JEWELRY_GOALS: readonly GalleryGoalOption[] = [
  { value: 8192, label: "Manage stock", analyticsLabel: "Manage Stock" }, // ManageStock
  { value: 16384, label: "Issue certificates", analyticsLabel: "Certificates" }, // Certificates
  { value: 32, label: "Sell on the marketplace", analyticsLabel: "Marketplace" }, // Marketplace (reused, see above)
  { value: 16, label: "Run our business", analyticsLabel: "Business Operations" }, // BusinessOperations (reused, see above)
] as const;
